module.exports = __webpack_public_path__ + "static/media/opt_gsdk_new_thumbnail.c2eb2e37.jpg";